<template>
    <div class="vertical icon-button" style="justify-content: center; align-items: center;" @click="onClick">
      <slot></slot>
      <span class="icon-text noselect">{{text}}</span>
      <div class="selected"></div>
    </div>
</template>
<script>
export default { 
  props: ['icon', 'text'],
  data() {
    return {
    };
  },
  methods: {
    onClick() {
      this.$emit('onClick');
    }
  },
  mounted(){
  }
}
</script>

<style scoped>
.icon-text {
  margin-top: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/IconButton.vue